function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawInThePool = function UndrawInThePool(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1081 814.87",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 520.59,
    y1: 754,
    x2: 520.59,
    y2: 202.22,
    gradientTransform: "rotate(12.01 550.596 492.008)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), React.createElement("path", {
    d: "M193.7 22.43s-257.81-13-172.66 305C69.7 509.19 39.19 623.31 4.1 687.75c-14.47 26.57 11.34 56.31 45.68 52.78 114.72-11.79 318.41-15.1 563.72 57.9 294.72 87.68 420.82-198.53 463.33-335.34 12.51-40.25-3.87-83-41.82-109.47-109.87-76.71-331.95-240.81-322.14-307.19 13.01-88-519.17-24-519.17-24z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M584.43 156.68A262.33 262.33 0 0 0 496 141.43c-145.25 0-263 117.75-263 263a262.18 262.18 0 0 0 77.43 186.36c13-4.32 35.61-9.8 57.09-5.28 0 0 90.54-43.11 140.55 52.6l19.83 27.39a261.18 261.18 0 0 0 39.6-7.92C678 626.43 759 524.9 759 404.43c0-114.22-72.82-211.44-174.57-247.75zm-88 333.12c-48.34 0-87.52-37.83-87.52-84.5s39.19-84.5 87.52-84.5 87.52 37.83 87.52 84.5-39.18 84.5-87.52 84.5z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M681.19 456.15c-14.82-47.94 25.31-104.25.22-147.72-3.84-6.63-9.06-12.51-11.89-19.63-4.85-12.2-2-26.21-5.7-38.8-9.86-33.68-58.52-40.64-73.76-72.25a42.2 42.2 0 0 1-3.91-21.09 262.33 262.33 0 0 0-88.43-15.23c-145.25 0-263 117.75-263 263a262 262 0 0 0 66.69 175q5.2 5.83 10.74 11.35c13-4.32 35.61-9.8 57.09-5.28 0 0 87.66-41.74 138.11 48.1q1.24 2.2 2.44 4.5l19.83 27.39a261.18 261.18 0 0 0 39.61-7.92c21-25.44 28.74-62 55.42-81.65 10.12-7.46 22.31-11.85 32.09-19.76 13.82-11.18 21.44-28.12 28.56-44.41 2.76-6.31 5.56-12.79 6-19.66.74-12.51-6.41-23.95-10.11-35.94zm-183 33.66c-48.34 0-87.52-37.83-87.52-84.5s39.19-84.5 87.52-84.5 87.52 37.83 87.52 84.5-39.21 84.49-87.55 84.49z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M679.5 456.15c-14.81-47.94 25.36-104.25.22-147.69-3.84-6.63-9.06-12.51-11.89-19.63-4.85-12.2-2-26.21-5.7-38.8-9.86-33.68-58.52-40.64-73.76-72.25a42.2 42.2 0 0 1-3.91-21.09A262.33 262.33 0 0 0 496 141.43c-145.25 0-263 117.75-263 263a262 262 0 0 0 66.69 175q5.2 5.83 10.74 11.35c13-4.32 35.61-9.8 57.09-5.28 0 0 87.66-41.74 138.11 48.1q1.24 2.2 2.44 4.5l19.83 27.39a261.18 261.18 0 0 0 39.6-7.91c21-25.44 28.74-62 55.42-81.65 10.12-7.46 22.31-11.85 32.09-19.76 13.82-11.18 21.44-28.12 28.56-44.41 2.76-6.31 5.56-12.79 6-19.66.75-12.52-6.41-23.96-10.07-35.95zm-183 33.66c-48.34 0-87.52-37.83-87.52-84.5s39.19-84.5 87.52-84.5 87.52 37.83 87.52 84.5-39.25 84.49-87.59 84.49z",
    fill: "#636e7e"
  }), React.createElement("rect", {
    x: 345.96,
    y: 354.74,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(-18.45 190.44 543.005)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 389.94,
    y: 569.45,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(99.08 383.514 549.094)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 389.94,
    y: 434.94,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(42.53 420.057 363.538)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 417.53,
    y: 498.75,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(-18.45 262.026 687.058)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 345.1,
    y: 354.74,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(-18.45 189.583 543.024)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 438.23,
    y: 327.15,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(42.53 468.347 255.747)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 567.57,
    y: 275.41,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(19.9 664.277 110.802)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 646.04,
    y: 278.86,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(-7.61 301.667 731.235)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 493.41,
    y: 266.79,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(-70.1 438.512 314.214)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 692.6,
    y: 352.16,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(19.9 789.293 187.555)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 548.6,
    y: 207.29,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(60 560.892 160.774)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 437.37,
    y: 327.15,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(42.53 467.486 255.742)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 566.71,
    y: 275.41,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(19.9 663.425 110.805)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 645.18,
    y: 278.86,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(-7.61 300.76 731.25)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 492.55,
    y: 266.79,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(-70.1 437.65 314.215)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 691.74,
    y: 352.16,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(19.9 788.437 187.529)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 687.43,
    y: 459.94,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(63.87 696.986 417.202)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 621.03,
    y: 591.01,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(99.08 614.612 570.645)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 657.25,
    y: 528.06,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(-45 581.297 604.899)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 686.57,
    y: 459.94,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(63.87 696.124 417.194)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 620.17,
    y: 591.01,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(99.08 613.745 570.648)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 389.08,
    y: 569.45,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "matrix(-.16 .99 -.99 -.16 985.25 257.89)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 389.08,
    y: 434.94,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(42.53 419.197 363.532)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 464.1,
    y: 537.55,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(11.44 652 245.57)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 463.23,
    y: 537.55,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(11.44 651.146 245.605)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 656.39,
    y: 528.06,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(-45 580.43 604.908)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 551.19,
    y: 562.56,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(45 577.993 495.752)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 550.33,
    y: 562.56,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(45 577.131 495.756)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 547.74,
    y: 207.29,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(60 560.028 160.776)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 416.67,
    y: 498.75,
    width: 10.35,
    height: 52.6,
    rx: 5.17,
    ry: 5.17,
    transform: "rotate(-18.45 261.175 687.046)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M505.63 633.62c-50.45-89.84-138.13-48.1-138.13-48.1-21.48-4.52-44.07 1-57.09 5.28q-5.54-5.51-10.74-11.35c15.91-5.26 47.56-14 67-7.73-.01 0 107.2-40.04 138.96 61.9z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M366.66 573.43s104.4-39 137.67 57.93c.43.75.87 1.48 1.3 2.24-31.76-101.94-139-61.9-139-61.9-19.4-6.26-51.06 2.47-67 7.73.4.45.82.88 1.22 1.33 16.32-5.27 46.88-13.42 65.81-7.33z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M195.85 575.75c-31-52.1-49.32-107.44-54.48-164.47-4.13-45.62.1-92.41 12.59-139.08 21.25-79.42 59.65-131.7 60-132.22l4 3c-.38.51-38.28 52.17-59.27 130.72-19.33 72.37-27.84 183.08 41.41 299.52z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M251.85 586.75c-31-52.1-49.32-107.44-54.48-164.47-4.13-45.62.1-92.41 12.59-139.08 21.25-79.42 59.65-131.7 60-132.22l4 3c-.38.51-38.28 52.17-59.27 130.72-19.33 72.37-27.84 183.08 41.41 299.52zM764.27 682.34c39.74-45.77 67.6-97 82.81-152.19 12.17-44.16 16.3-91 12.3-139.1-6.82-81.93-35.32-140.2-35.61-140.78l-4.48 2.22c.28.57 28.42 58.13 35.12 139.16 6.18 74.65-5.1 185.11-93.92 287.41z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M707.21 683.23c39.74-45.77 67.6-97 82.81-152.19 12.17-44.16 16.3-91 12.3-139.1-6.82-81.93-35.32-140.2-35.61-140.78l-4.48 2.22c.28.57 28.42 58.13 35.12 139.16 6.18 74.65-5.1 185.11-93.92 287.41zM350.8 690.91a148 148 0 0 0 55.49 35.69 151.54 151.54 0 0 0 52.48 8.54c31.3-.31 54.22-9.51 54.45-9.6l-.72-1.76c-.23.09-22.87 9.17-53.82 9.46-28.52.27-70.15-7.09-106.53-43.67z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M392.98 698.32a68.74 68.74 0 0 0 25.77 16.57 70.37 70.37 0 0 0 24.37 4 76.13 76.13 0 0 0 25.28-4.46l-.33-.82a75.23 75.23 0 0 1-25 4.39 67.49 67.49 0 0 1-49.47-20.28zM470.44 703.5a68.74 68.74 0 0 0 16.3-25.94 70.37 70.37 0 0 0 3.71-24.41 76.13 76.13 0 0 0-4.72-25.24l-.82.34a75.23 75.23 0 0 1 4.66 24.95 67.49 67.49 0 0 1-19.76 49.68zM426.28 605.09a68.74 68.74 0 0 0-18.14 24.69 70.37 70.37 0 0 0-5.47 24.08 76.13 76.13 0 0 0 2.88 25.51l.84-.28a75.23 75.23 0 0 1-2.83-25.22 67.49 67.49 0 0 1 23.31-48.11z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 134,
    cy: 163.47,
    rx: 23,
    ry: 63,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 690,
    cy: 153.47,
    rx: 23,
    ry: 38,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 1006.5,
    cy: 437.43,
    rx: 23,
    ry: 38,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 178.5,
    cy: 661.47,
    rx: 103.5,
    ry: 63,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M633.49 414.93C645 402.72 646 385.66 646 385.66l3.06-27c2-13.39-.32-32-.32-32s7.63-48.42-24.15-45.7c0 0-2.13.38-5.25.76-1.09.13-2.3.26-3.59.37-2.45.22-5.16.37-7.8.34a6.4 6.4 0 0 0 .34-1.3c.76-2.65-.2-6-.33-9a15.29 15.29 0 0 1 .3-3.67c1.44-5.89 5.73-11.21 7.68-17.14a22.65 22.65 0 0 0 .77-3.07 24.84 24.84 0 0 0-5.31-21.12c-2-2.3-4.34-4.26-6.15-6.67-3.31-4.4-4.66-10.2-8.94-13.72-5.12-4.23-9.85-2.21-15.29-.68-2.94.83-4.36-.46-7.11-1.73a46.61 46.61 0 0 0-10.17-3.35c-2.52-.52-5.27-.8-7.53.35-3.93 2-4.68 7.2-7.88 10.17s-7.93 3.16-11.42 5.56a12 12 0 0 0-3.31 3.51l-27.18 4.15-32 7.86s-13 6.72 3.93 27.59c10.58 13 21.89 25.86 28.9 33.67-1.44 1.8-3 3.54-4.54 5.23-1.42 1.53-2.9 3.12-3.48 5.1a6.78 6.78 0 0 0-.17.81c-1.56 5.38 4 10.4 4.48 16a9.51 9.51 0 0 1-.12 2.37c-.83 3.25-3.15 6.19-5.45 8.79s-4.72 5.15-6.18 8.26a13.36 13.36 0 0 0-1 3.16 9.77 9.77 0 0 0 .81 7.58c1.47 2.42 4.1 3.91 6.61 5.3 1.64.9 3.4 1.84 5.28 1.75 1.59-.07 3.08-.88 4.67-.87 4.69 0 6.74 6.39 11.22 7.81a5.88 5.88 0 0 0 7.32-4.56c0-.13.07-.26.1-.39l10.2 5.3a5.61 5.61 0 0 0 3.26.91c1.77-.25 2.71-2.06 3-3.84a7.19 7.19 0 0 0 .25-1.53 14.15 14.15 0 0 0-.12-2.57h.4l.12.25.74-.07.12.25 1.6-.14v.56c.59 9.14-.25 18.36-5.36 21.23-9.2 5.17-20.33 22.28-23.92 28.08l-.18-.25a3.4 3.4 0 0 1-.23.91c-.5.81-.78 1.29-.78 1.29l-.75 1.62c-3.6 5.79-11.49 15-11.49 15l.34.15-.52.68c-5.16 6.92-10.89 20.78-9.49 47.74l4.54 41.52 4.44 29.42s1.05 24.38-.5 27.51l-3.69 17.34s-6.8 23.58-3.14 39.89l.57 18.24 2.65 42-1.23 5.78-2.69 21S468 736.09 490 745.94s21.72-5.73 21.72-5.73l2.64-12.38 1.41-15.83a57.67 57.67 0 0 0-.19-12.26l-.88-7.16 2.52-12.6v-.24c.36 3 6.93-3.05 11.89-8.13a29.77 29.77 0 0 0 7.46-13l5.9-21.44c6.72-10.65 2-17.7 2-17.7l6.83-27.89s11.59-25.15 5-36-2.48-13.47-2.48-13.47L587 507.73c22.09-22.36 26.13-37.35 26.08-45.43l.49.17a3.43 3.43 0 0 1-.41-1l.59.2a3.43 3.43 0 0 1-.41-1l.59.2c-2-3 .45-20.39.45-20.39l.13-.88c4.03-6.17 11.37-16.6 18.98-24.67zm-86 63.85l.12.39c-.3.82-.61 1.65-.93 2.46zm68.08-72.32l-1.14-1.22c-.79-3.78-2.21-14.56 4.76-23.55 3.61-4.66 5.43-12 6.33-18.9l.1-.81.33.09.83.22c-.8 14.3-.49 27.86-.49 27.86zM539 345.82a31.32 31.32 0 0 1-1.51-11.95c0-.44.08-.88.15-1.32a5.62 5.62 0 0 1 .49-1.29c.06-.11.14-.2.21-.3a26.9 26.9 0 0 0-.2 4.15 73.84 73.84 0 0 0 1.31 12c-.14-.44-.29-.86-.45-1.29zm-24-106.41a49.71 49.71 0 0 0 6.56-1.68 65.12 65.12 0 0 1 7.55-2.13c-1.53 6.93-3.82 13.81-9.17 18.41-3 2.59-7.11 4.68-7.88 8.53 0 .13 0 .26-.06.38s-.09.29-.12.44a7.11 7.11 0 0 0-.07 2.25A149 149 0 0 1 496.14 252s10.99-11 18.86-12.59zm9.09 405.92L528.6 623v-5.34c.51 3.32.82 5.52.82 5.52s-2.52 10.31-5.28 22.15z",
    transform: "translate(-59.5 -42.57)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M552.12 366.12c4.13 12.92-2.52 44.18-2.52 44.18l-57.17-6.15-39.1-26.38 3.22-7.05s13.65-23.75 24.46-30.05c4.95-2.89 5.82-12.07 5.31-21.16a139.44 139.44 0 0 0-3.14-21.38 42.71 42.71 0 0 0-3.3-8.19c-8.07-15.54-24.3-27.78-24.3-27.78s-18.08-20.19-34.32-40.84-3.62-27.43-3.62-27.43l30.95-8 36.53-6-3.68 17.28c-3.52-3.14-12.87-.44-18.22 1.49a47.35 47.35 0 0 1-6.35 1.71c-7.66 1.65-18.35 12.61-18.35 12.61 21.93 22.15 30.83 22.19 52.51 32.91l2.18 1.09c.43.22.86.42 1.27.61 21.36 9.76 4.51-27.76 4.51-27.76l27.67 3.31s3 10.1 7.72 16.26c2.82 3.69 12.31 3.56 19.47 2.85 1.25-.12 2.42-.26 3.47-.4 3-.4 5.08-.79 5.08-.79 30.72-2.92 23 45.32 23 45.32l-15.84 3.43-2.19.47-3.8 13.81a113.45 113.45 0 0 1-.82 18.34c-.92 6.9-2.72 14.2-6.24 18.86-8.35 11.09-4.39 24.83-4.39 24.83z",
    fill: "#ffb9b9"
  }), React.createElement("circle", {
    cx: 567.28,
    cy: 257.36,
    r: 29.44,
    transform: "rotate(-77.99 511.211 272.83)",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 567.63,
    cy: 255.71,
    r: 29.44,
    transform: "rotate(-77.99 511.564 271.182)",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M429.34 704.62c-21.16-9.66 5-27.32 5-27.32l2.73-20.92 1.23-5.76-2.29-41.77-.51-18.15c-3.43-16.21 3.29-39.72 3.29-39.72l3.71-17.27c1.52-3.12.67-27.38.67-27.38l-4.09-29.25-4.11-41.29c-2.06-46.88 16.67-54.07 16.67-54.07l14.53 12.55 24.17 27.68.73.83-10.57 37.32-11.94 31.86-1.06 90.06-11.37 56.73-2.52 12.55.8 7.12a59.08 59.08 0 0 1 .11 12.2l-1.53 15.81-2.63 12.34s.14 15.52-21.02 5.85z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M456.11 638.75c-.91.39-1.5.28-1.6-.58-.53-4.84 12.14-56.32 12.14-56.32s-4.22-32.72-7.63-36.88-3.68-23.14-3.68-23.14l-2.2-22a31.65 31.65 0 0 1 11.36-25.08 124.7 124.7 0 0 0 22.66-42.48l3.15-10.33.73.83-10.54 37.33-11.94 31.86-1.06 90.06z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M492.38 501.32s-4 2.59 2.31 13.39-5.06 35.9-5.06 35.9l-6.77 27.82s4.53 7-2 17.63l-5.87 21.37a30.35 30.35 0 0 1-7.29 12.94c-4.82 5.08-11.22 11.17-11.54 8.16-.53-4.84 12.14-56.32 12.14-56.32s-4.22-32.72-7.63-36.88-3.68-23.14-3.68-23.14l-2.2-22a31.65 31.65 0 0 1 11.36-25.1 124.7 124.7 0 0 0 22.66-42.48l6.15-20.18 16.86-2.43 8.39 1 25.68 3.07 2.83.33s10.19 16.79-24.07 52.5z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M457.18 370.17s24 35.47 94 31.23c0 0-2.51 17.31-.56 20.3 0 0-34.64-13.22-63.73 17.48 0 0-9.32-35.9-42.62-50.15-.01 0 12.67-15.3 12.91-18.86z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M457.5 368.52s24 35.47 94 31.23c0 0-2.51 17.31-.56 20.3 0 0-34.64-13.22-63.73 17.48 0 0-9.32-35.9-42.62-50.15.02.05 12.7-15.3 12.91-18.86z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M457.35 369.35s24 35.47 94 31.23c0 0-2.51 17.31-.56 20.3 0 0-34.64-13.22-63.73 17.48 0 0-9.32-35.9-42.62-50.15-.01 0 12.67-15.3 12.91-18.86z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M518.5 363.07a2.12 2.12 0 0 1 2-2.55c1 0 2.18.14 2.43 1.12a2.59 2.59 0 0 1-.76 2.21 2.12 2.12 0 0 1-3.68-.71zM525.76 281.86s-.93 23.87 3.5 26.47 3.45-8.4 3.45-8.4-2.36-16.26-6.95-18.07zM518.16 283.22s7.72 16.26-.61 23.09.82.18.82.18l4.11.88s4.15-15.46-3.5-24",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M503.95 162.68c-2.43-.5-5.08-.76-7.28.39-3.81 2-4.57 7.2-7.68 10.17s-7.68 3.19-11.07 5.61c-4.37 3.12-5.69 8.92-6.7 14.2-1.59 8.23-3.58 17.05-9.84 22.62-2.92 2.6-6.9 4.71-7.67 8.54-.6 2.94 1 5.83 1.74 8.73 1.34 5 .28 10.46-2 15.15s-5.63 8.74-9.11 12.6a13.73 13.73 0 0 0-3.39 5.1c-1.54 5.37 3.83 10.32 4.22 15.89.32 4.52-2.67 8.54-5.63 12-2.24 2.59-4.59 5.16-6 8.26s-1.82 6.91-.09 9.87c1.4 2.4 3.94 3.87 6.36 5.23 1.58.89 3.27 1.81 5.09 1.71 1.54-.08 3-.89 4.52-.9 4.53 0 6.47 6.32 10.79 7.7a5.74 5.74 0 0 0 7.14-5l9.87 5.24a5.25 5.25 0 0 0 3.15.89c1.94-.3 2.87-2.58 3-4.54.3-5.28-2.58-10.14-4.16-15.19a31.91 31.91 0 0 1-1.38-11.88 8.46 8.46 0 0 1 .81-3.43c1.31-2.42 4.3-3.27 6.48-4.95 3-2.34 4.36-6.26 4.83-10s.23-7.64.84-11.41a4 4 0 0 1 .64-1.82 4.63 4.63 0 0 1 2.35-1.31c6.44-2.15 12.93-7.36 12.59-14.13-.22-4.42-3.3-8.15-6.6-11.11s-7-5.59-9.31-9.37c-3.28-5.44-3-12.45-.72-18.39s6.25-11 10.21-16a9.72 9.72 0 0 1 3.58-3.21 8 8 0 0 1 4.1-.31c10.52 1.38 19.19 11.41 19 22-.06 3.72-1.05 7.59.25 11.08.72 1.95 2.13 3.66 2.38 5.72.28 2.33-1 4.63-.73 7 .3 2.62 2.43 4.6 4.43 6.32a18.73 18.73 0 0 0 5.7 3.81c2.16.77 4.82.63 6.47-1 2.83-2.72 1.28-7.37 1.13-11.3-.3-7.75 5.62-14.21 8-21.59a25 25 0 0 0-4.4-23.22c-1.88-2.28-4.17-4.21-5.9-6.6-3.17-4.36-4.44-10.12-8.55-13.6-4.92-4.17-9.5-2.13-14.77-.57-2.85.84-4.21-.43-6.86-1.67a43.59 43.59 0 0 0-9.83-3.33z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M491.5 279.26l-4.81 2.42 4.35-35.82 2.18 1.09c.43.22.86.42 1.27.61z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M504.12 161.86c-2.43-.5-5.08-.76-7.28.39-3.81 2-4.57 7.2-7.68 10.17s-7.68 3.19-11.07 5.61c-4.37 3.12-5.69 8.92-6.7 14.2-1.59 8.23-3.58 17.05-9.84 22.62-2.92 2.6-6.9 4.71-7.67 8.54-.6 2.94 1 5.83 1.74 8.73 1.34 5 .28 10.46-2 15.15s-5.63 8.74-9.11 12.6a13.73 13.73 0 0 0-3.39 5.1c-1.54 5.37 3.83 10.32 4.22 15.89.32 4.52-2.67 8.54-5.63 12-2.24 2.59-4.59 5.16-6 8.26s-1.82 6.91-.09 9.87c1.4 2.4 3.94 3.87 6.36 5.23 1.58.89 3.27 1.81 5.09 1.71 1.54-.08 3-.89 4.52-.9 4.53 0 6.47 6.32 10.79 7.7a5.74 5.74 0 0 0 7.14-5l9.87 5.24a5.25 5.25 0 0 0 3.15.89c1.94-.3 2.87-2.58 3-4.54.3-5.28-2.58-10.14-4.16-15.19a31.91 31.91 0 0 1-1.38-11.88 8.46 8.46 0 0 1 .81-3.43c1.31-2.42 4.3-3.27 6.48-4.95 3-2.34 4.36-6.26 4.83-10s.23-7.64.84-11.41a4 4 0 0 1 .64-1.82 4.63 4.63 0 0 1 2.35-1.31c6.44-2.15 12.93-7.36 12.59-14.13-.22-4.42-3.3-8.15-6.6-11.11s-7-5.59-9.31-9.37c-3.28-5.44-3-12.45-.72-18.39s6.25-11 10.21-16a9.72 9.72 0 0 1 3.58-3.21 8 8 0 0 1 4.1-.31c10.52 1.38 19.19 11.41 19 22-.06 3.72-1.05 7.59.25 11.08.72 1.95 2.13 3.66 2.38 5.72.28 2.33-1 4.63-.73 7 .3 2.62 2.43 4.6 4.43 6.32a18.73 18.73 0 0 0 5.7 3.81c2.16.77 4.82.63 6.47-1 2.83-2.72 1.28-7.37 1.13-11.3-.3-7.75 5.62-14.21 8-21.59a25 25 0 0 0-4.4-23.22c-1.88-2.28-4.17-4.21-5.9-6.6-3.17-4.36-4.44-10.12-8.55-13.6-4.92-4.17-9.5-2.13-14.77-.57-2.85.84-4.21-.43-6.86-1.67a43.59 43.59 0 0 0-9.83-3.33z",
    fill: "#896363"
  }), React.createElement("path", {
    d: "M580.76 344.7s-1 17-12.24 29.21-21.81 29.76-21.81 29.76l-5.72 22.86s-3.43 24.21-22 18.54c-8.36-2.55-10-9.6-9.3-16.58a33.15 33.15 0 0 1 13.18-22.95l5.4-4.08 23.53-36.73 2.93 3.23 11.61-18.17z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M542.28 428.52s-3.43 24.21-22 18.54c-8.36-2.55-10-9.6-9.3-16.58a32.77 32.77 0 0 1 9.24-19.47l25.68 3.07z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M581.9 278.72l3.54 7.63s2.08 18.5.1 31.84l-3.13 26.85s-1 17-12.24 29.21-21.81 29.76-21.81 29.76l-5.72 22.86s-3.43 24.21-22 18.54c-8.36-2.55-10-9.6-9.3-16.58a33.15 33.15 0 0 1 13.16-22.94l5.4-4.08 33.47-52.22s-.65-41.42 5-55.7l-3.19-9.28z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M562.79 322.43a46.92 46.92 0 0 0-11.09-1.49c-13.1-.21-24.5-7.4-24.5-7.4l-8.4-.93c-8 6.48-15.2 7.36-19.66 7a84.83 84.83 0 0 0-12.82-.1 139.44 139.44 0 0 0-3.14-21.38 42.71 42.71 0 0 0-3.3-8.19 26.08 26.08 0 0 1 10-15.32c22.27.44 31.3 30.74 31.3 30.74l6.58 1.4c8.07-25.8 31.26-33.77 31.26-33.77 7.31 3.27 9.74 11.58 10.56 16.79l-2.19.47-3.8 13.81a113.45 113.45 0 0 1-.8 18.37z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M560.03 272.35s-23.19 8-31.26 33.77l-6.58-1.4s-9-30.3-31.3-30.74a26.16 26.16 0 0 0-10.66 21.81c.31 14.69 4.5 23.32 4.5 23.32a80.87 80.87 0 0 1 15.4-.15c4.47.35 11.62-.52 19.66-7l8.4.93s11.4 7.19 24.5 7.4a47.39 47.39 0 0 1 12.16 1.77s9.32-19.16 6.14-28.44c0-.02.04-16.35-10.96-21.27z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M558.39 272s-23.19 8-31.26 33.77l-6.58-1.4s-9-30.3-31.3-30.74a26.16 26.16 0 0 0-10.67 21.8c.31 14.69 4.5 23.32 4.5 23.32a80.87 80.87 0 0 1 15.4-.15c4.47.35 11.62-.52 19.66-7l8.4.93s11.4 7.19 24.5 7.4a47.39 47.39 0 0 1 12.16 1.77s9.32-19.16 6.14-28.44c0-.01.04-16.34-10.95-21.26z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M559.21 272.17s-23.19 8-31.26 33.77l-6.58-1.4s-9-30.3-31.3-30.74a26.16 26.16 0 0 0-10.66 21.81c.31 14.69 4.5 23.32 4.5 23.32a80.87 80.87 0 0 1 15.4-.15c4.47.35 11.62-.52 19.66-7l8.4.93s11.4 7.19 24.5 7.4a47.39 47.39 0 0 1 12.16 1.77s9.32-19.16 6.14-28.44c0-.01.03-16.35-10.96-21.27z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M562.45 277.16l-2.82 1.12-5.78-36.06c1.25-.12 2.42-.26 3.47-.4z",
    fill: "#fff"
  }), React.createElement("ellipse", {
    cx: 438.75,
    cy: 660.97,
    rx: 61.75,
    ry: 71.5,
    fill: primaryColor,
    opacity: 0.1
  }));
};
UndrawInThePool.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawInThePool;